import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UploadFilesService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  get urlBase() {
    return this.baseUrl;
  }

  uploadFile(sessionId: string, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('sessionId', sessionId);
    return this.http.post<any>('api/uploadFile', formData, {reportProgress: true, observe: 'events'});
  }

  deleteFile(sessionId: string, fileName: string) {
    return this.http.post<any>('api/deleteFile', { sessionId: sessionId, fileName: fileName });
  }

  /*
  *
  * importSystemFlow(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post('api/systemFlow/uploadSystemFlow', formData, {reportProgress: true, observe: 'events'});
  }*/
  //api/postEndpoint
}
